import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import BusinessTypesDropdown from '../../../../../../components/BusinessTypesDropdown';
import FormInput from '../../../../../../components/form/FormInput';
import { analyticsIds } from '../../../../../../constants/analyticsIds';
import CompanySettingTypes from '../../../../../../constants/companySettings';
import { inAppText } from '../../../../../../constants/inAppText';
import { getValidationObject } from '../../../../../../constants/regexPatterns';
import { selectCompanySettingValue } from '../../../../../../redux/modules/company';
import UseFormMethodsType from '../../../../../../types/UseFormMethodsType';
import FormCollapse from '../FormCollapse';

const InsuredInfoSection = ({ useFormMethods }) => {
  const disableExternalId = useSelector(selectCompanySettingValue(CompanySettingTypes.ReportsHideNonPolicyHolders));
  const [infoOpen, setInfoOpen] = useState(false);
  const { setValue } = useFormMethods;

  const onTypeChange = value => {
    setValue('insuredType', value);
  };

  return (
    <FormCollapse dusk="insuredInformationCollapse" isOpen={infoOpen} title="Insured Information" toggle={() => setInfoOpen(!infoOpen)}>
      {!disableExternalId && (
        <FormInput
          disableEnterKey
          dataAnalyticsId={analyticsIds.insuredsListPage.createInsuredForm.insuredIdInput}
          dusk={analyticsIds.insuredsListPage.createInsuredForm.insuredIdInput}
          inputName="externalId"
          labelName="Insured ID"
          placeholder="EX1234"
          toolTip={inAppText.tooltips.insureds.newInsured.insuredId}
          type="standard"
          useFormMethods={useFormMethods}
          validationRules={getValidationObject('alphaNumericAndCharacters')}
        />
      )}
      <BusinessTypesDropdown onChange={onTypeChange} />
      <FormInput
        disableEnterKey
        dataAnalyticsId={analyticsIds.insuredsListPage.createInsuredForm.descriptionInput}
        inputName="insuredDescription"
        labelName="Insured Description"
        placeholder="Insured description here"
        toolTip={inAppText.tooltips.insureds.newInsured.insuredDescription}
        type="textAreaSm"
        useFormMethods={useFormMethods}
      />
    </FormCollapse>
  );
};

InsuredInfoSection.propTypes = { useFormMethods: UseFormMethodsType };

export default InsuredInfoSection;
